import { Avatar, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useAuthContext } from "../../../context/authContext";

export default function AvatarComponent({ size, open, onClick, sx }) {
  const { user } = useAuthContext();
  const names = user?.name?.split(" ");
  console.log();

  const aSize = size ? size : 38;
  return (
    <Tooltip title="My Account">
      <IconButton
        onClick={onClick}
        size="small"
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <Avatar
          sx={{
            width: aSize,
            height: aSize,
            bgcolor: "primary.main",
            fontSize: aSize / 2.3,
            ...sx,
          }}
        >
          {names?.[0][0]}
          {names?.[1]?.[0]}
        </Avatar>
      </IconButton>
    </Tooltip>
  );
}
